import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { autenticarUsuario } from '../../services/http/autenticarService';
import { trackPromise } from 'react-promise-tracker';
import services from '../../services';
import cookies from 'js-cookie';

import {
  buscarArquivosPertoDaValidade
} from '../../services/http/arquivoServico';

import {
  notification
} from 'antd';

import './styles.scss';

const LoginIntegracao = () => {
    const history = useHistory();
    
    useEffect(() => {
        sessionStorage.clear();
    }, [])

    useEffect(() => {
        const token = cookies.get('token');

        if (token) {
          const data = { encriptedValueAes: token }
          trackPromise(
            autenticarUsuario(data)
              .then(res => {
                if (!res.fail && res.data) {
                  services.storage.set('isAuthenticated', true);
                  sessionStorage.setItem('authSistema', res.data)
                  
                  buscarArquivosPertoDaValidade()
                    .then(res => {
                      if (!res.fail && res.data) {
                        let mensagem = res.data.map(item => `Arquivo ${item.nome}, irá expirar em ${item.diasFaltantes} dias \n`);

                        if (mensagem) {
                          notification.info({
                            message: 'Arquivos perto da data de validade',
                            description: mensagem,
                            duration: 30
                          })
                        }
                      }
                    })
                    .catch(error => {
                      console.error('erro ao buscar arquivos perto da validade');
                    })
                  
                    history.push('/galeria-midia');
              }
            }).catch(error => {
              console.error(error);
            })
        )
        }
    })

    return (
        <div></div>
    )
}

export default LoginIntegracao;